import React from 'react';
import PropTypes from 'prop-types';

const NotFoundPage = ({ classes, logger, history, browserHistory }) => {
  React.useEffect(() => {
    logger.warn('User has been navigated to 404 page', {
      moduleRoute: history.location.pathname,
      browserRoute: browserHistory?.location.pathname,
    });
  }, []);

  return <div className={classes.message}>404 Page Not Found</div>;
};

NotFoundPage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  logger: PropTypes.shape({ warn: PropTypes.func.isRequired }).isRequired,
  history: PropTypes.shape({}).isRequired,
  browserHistory: PropTypes.shape({}),
};

NotFoundPage.defaultProps = {
  classes: {},
};

export default NotFoundPage;
